import { featureDisabledMessage, type FeatureKey } from '@aiai/shared';
import { Callout } from './Callout';

/** The one quiet "not included" state for an operator-disabled feature. No upsell. */
export function FeatureLocked({ feature, className }: { feature: FeatureKey; className?: string }) {
  return (
    <Callout tone="info" className={className}>
      {featureDisabledMessage(feature)}
    </Callout>
  );
}
